import { useCallback } from 'react';
import debounce from '../lib/debounce.js';

const useScrollPagination = (fn) => {
  const onDebounceChange = useCallback(debounce(fn, 200));
  const handleScrollPaginationReachBottom = (e) => {
    const ceilScrollTop = Math.ceil(e.target.scrollTop);
    let bottom = e.target.scrollHeight - ceilScrollTop === e.target.clientHeight;
    if (e.target.scrollHeight === e.target.clientHeight) {
      bottom = false;
    }
    if (bottom) {
      onDebounceChange();
    }
  };
  const handleScrollPaginationReachTop = (e) => {
    const ceilScrollTop = Math.abs(Math.ceil(e.target.scrollTop));
    const scrollHeight = Math.abs(e.target.scrollHeight - e.target.offsetHeight);
    const bounds = Math.abs(ceilScrollTop - scrollHeight);
    if (bounds === scrollHeight) {
      onDebounceChange();
    }
  };
  return [handleScrollPaginationReachBottom, handleScrollPaginationReachTop];
};

export { useScrollPagination };
